import {
  CruiseIcon,
  HotelIcon,
  LuggageIcon,
  PlaneLanding,
} from '@assets/icons';
import {
  KidInterface,
  ListingSearchRoomInterface,
} from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import { ITabItemProps } from '@components/ui/tab/Tab';
import { validRoomChildAge } from '@components/views/hotel/listing/components/ResponsiveSearch/ResponsiveListingSearchGuest';

export const BookerTabItems: ITabItemProps[] = [
  {
    title: 'Otel',
    icon: HotelIcon,
  },
  {
    title: 'Uçak',
    icon: PlaneLanding,
  },
  {
    title: 'Tur',
    icon: LuggageIcon,
  },
  {
    title: 'Gemi',
    icon: CruiseIcon,
    disabled: true,
  },
];

export const hotelItemsTOStringify = [
  'rooms',
  'slug',
  'in',
  'text',
  'itemText',
  'out',
  'url',
  'id',
  'title',
  'adultCount',
  'childrenList',
  'closable',
  'error',
  'key',
  'ref',
  'age',
  'itemType',
  'type',
  'redirectUrl',
];

export const generateSearchRooms = (
  hotelRooms: ListingSearchRoomInterface[]
) => {
  const rooms = hotelRooms.map(
    (item: ListingSearchRoomInterface) =>
      `${item.adultCount}${
        item.childrenList.length > 0 ? ',' : ''
      }${item.childrenList.map((item: KidInterface) =>
        item.age.toString().replaceAll('/', '-').split('-').reverse().join('-')
      )}`
  );

  let roomUrlStr = '';
  rooms.forEach((item) => {
    roomUrlStr += `room=${item}&`;
  });
  roomUrlStr = roomUrlStr.slice(0, -1);

  return roomUrlStr;
};

export const hotelMaxAge = 15;

// ==========================================
// Validate a children array of type KidInterface
// ==========================================
export const validateChildren = (children: KidInterface[]) => {
  let isValid = true;

  for (const item of children) {
    if (!validRoomChildAge(String(item.age))) isValid = false;
  }
  return isValid;
};

// ================================================
// Validate a room array of type ListingSearchRoomInterface
// ================================================
export const validateGuestsChildrenAges = (
  hotelRooms: ListingSearchRoomInterface[]
) => {
  let isError = false;

  for (const item of hotelRooms) {
    if (!validateChildren(item.childrenList)) isError = true;
  }

  return isError;
};
